import { API } from "@swivl-mono/api-helper";
import { create } from "zustand";

import { Member } from "../Member/Member.Current";

export enum PushStatus {
  LOADING = "loading",
  NOT_REGISTERED = "not_registered",
  DENIED = "denied",
  PUSH_ENABLED_NOT_REGISTERED = "push_enabled_not_registered",
  ENABLED_AND_REGISTERED = "enabled"
}

interface StoreInterface {
  pushStatus: PushStatus;
  conversationsDesktopEnabled: boolean;
}

const BlankState: StoreInterface = {
  pushStatus: PushStatus.LOADING,
  conversationsDesktopEnabled: false
};

export default class PushNotificationsModel {
  static useState = create<StoreInterface>(() => ({ ...BlankState }));
  static setState = PushNotificationsModel.useState.setState;
  static get state() {
    return PushNotificationsModel.useState.getState();
  }

  static async refresh(): Promise<PushStatus> {
    const memberId = Member.id;
    const orgId = Member.member?.org?.id;
    if (!("Notification" in window) || !("serviceWorker" in navigator) || !memberId || !orgId) {
      PushNotificationsModel.setState({ pushStatus: PushStatus.NOT_REGISTERED });
      return PushStatus.NOT_REGISTERED;
    }

    const perm = Notification.permission;
    const registrations = await navigator.serviceWorker.getRegistrations();
    const subscriptionObjects = await API.Push.getSubscriptionObjects(orgId, memberId);

    let next: PushStatus;
    if (perm === "granted" && registrations.length > 0 && subscriptionObjects && subscriptionObjects.length > 0) {
      next = PushStatus.ENABLED_AND_REGISTERED;
    } else if ((perm === "granted" && registrations.length === 0) || !subscriptionObjects || subscriptionObjects.length === 0) {
      next = PushStatus.PUSH_ENABLED_NOT_REGISTERED;
    } else if (perm === "denied") {
      next = PushStatus.DENIED;
    } else {
      next = PushStatus.NOT_REGISTERED;
    }

    PushNotificationsModel.setState({ pushStatus: next });
    return next;
  }

  static async loadConversationsDesktopEnabled(): Promise<void> {
    const memberId = Member.id;
    const orgId = Member.member?.org?.id;

    if (!memberId || !orgId) return;

    try {
      const prefs = await API.NotificationPreferences.get(orgId, memberId);
      PushNotificationsModel.setState({ conversationsDesktopEnabled: !!prefs.preferences?.conversations?.desktop });
    } catch {
      // ignore
    }
  }
}
